// extracted by mini-css-extract-plugin
export default {"toast-messages":"toast-messages","toastMessages":"toast-messages"};